import {AuthStatus} from './AuthStatus';
import {isEnumValue} from '../../common/types/guards/isEnumValue';

export function isAuthStatus(o?: any): o is AuthStatus {
    return isEnumValue(o, AuthStatus);
}